module.exports = __webpack_public_path__ + "img/p4.756afd0d.svg";